import actionsTypes from "../actions/types";

export const defaultState = {
    "isLoading": true,
    "restaurant": null,
    "error": null,
    "search": null,
};

function reducer(state, action) {
    switch (action.type) {
        case actionsTypes.RESTAURANT_FETCHING: {
            return {
                ...state,
                "isLoading": true,
            }
        }
        case actionsTypes.RESTAURANT_SUCCESS: {
            return {
                ...state,
                "isLoading": false,
                "restaurant": action.restaurant,
            }

        }
        case actionsTypes.RESTAURANT_ERROR: {
            return {
                ...state,
                "isLoading": false,
                "restaurant": null,
                "error": action.error
            }
        }
        case actionsTypes.RESTAURANT_SEARCHING: {
            return {
                ...state,
                "isLoading": false,
                "search": action.search,
            }
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

export default reducer;
